<template>
  <div class="cv-chrono">
    <!-- 2023-present -->
    <CvChunk 
      yearRange="June 2023 - Present" 
      jobColumnHeader="Taskize" 
      jobColumnSubHead="Senior Software Engineer"
      >
      <div slot="jobContent">
        <p>At Taskize I work on our APIs and Integrations team helping build efficient, scalable and functional APIs and integrations with third party platforms.</p>
        <p>As well as working on our backend API infrastructure to improve performance and scalability I am also a key part of our AI Taskforce, building and prototyping practical AI solutions for our customers.</p>
        
      </div>
    </CvChunk>
    
    <!-- 2023-2023 -->
    <CvChunk 
      yearRange="May 2023 - June 2023" 
      jobColumnHeader="😎🌞 Spring Break 🌞😎" 
      jobColumnSubHead="Relax and Refocus"
      >
      <div slot="jobContent">
        <p>I am taking some time to relax first and foremost, then looking for exciting and engaging new work in climate tech, government, finance, funded PhDs or anything that piques my interest.</p>
        <p>If you'd like to chat about potential opportunities that might match this then check out my <a href="./assets/Lewis A Mckeown CV.pdf" target="_blank" title="Lewis A Mckeown CV - A professional PDF CV, so fancy">CV </a> and feel free to <a title="Opens your email client" href="mailto:lewisamckeown@gmail.com?subject=Spring%20break%20website%20contact&amp;body=How%20are%20you">get in touch</a>.</p>
      </div>
    </CvChunk>

    <!-- 2021-present -->
    <CvChunk 
      yearRange="2021 - April 2023" 
      jobColumnHeader="Fivium" 
      jobColumnSubHead="Senior Developer"
      >
      <div slot="jobContent">
        <p>At Fivium I help push for the appropriate use of applied machine learning in our products and services. I have worked on several research projects which use natural language processing to improve our existing products and given Dev talks about the process.</p>
        <p>One of these research projects has been developed and deployed as a production system helping improve user experience and data security.</p>
        <p>I have also worked on replacing a legacy search system with an elasticsearch implementation to greatly reduce database load and massively improve search performance and capabilities.</p>
        <p>When not working on research I do development day to day working with a small team designing, developing and deploying fully featured web applications which improve public sector processes and workflows.</p>
      </div>
    </CvChunk>

    <!-- 2017-2020 -->
    <CvChunk 
      yearRange="2017 - 2021" 
      jobColumnHeader="Fivium" 
      jobColumnSubHead="Developer"
      academiaColumnHeader="ICCC '18"
      academiaColumnSubHead="Paper Accepted to Conference"
      >
      <div slot="jobContent">
        <p>At Fivium I am working to help build robust, reliable and efficient software for the public sector.</p>

        <p>I work with a small team designing, developing and deploying fully featured web applications which improve public sector processes and workflows. </p>

        <p>As part of my team I am working hard to learn and communicate Java development best practices by attending conferences, reading the best available literature, discussing design decisions with anyone who will listen, and of course writing code!
        I am also working to improve our team wide communication by running a fortnightly catch up to present upcoming work, team changes and to knowledge share and discuss interesting problems solved in the last two weeks.</p>

        <p>Other exciting work includes helping to push for the use of applied machine learning at Fivium, working on a research project to use natural language processing in our existing products and giving a Dev talk about the process.</p>

        <p>I am also always keen to talk to colleagues about extra curricular activities such as using p5.js to emulate my favourite pieces of art, and different approaches to narrative generation and have given Dev talks on both of these topics.</p>
      </div>
      <div slot="academiaContent">
         <p>I presented <a href="http://computationalcreativity.net/iccc2018/sites/default/files/iccc_proc18.pdf" target="_blank">a paper</a> based on <router-link to="/thesis">my dissertation</router-link> at <a href="http://computationalcreativity.net/iccc2018/" target="_blank">the 9th International Conference on Computational Creativity in Salamanca, Spain in 2018</a>.</p>
         <p>The presentation took the form of a <a href="./assets/LM ICCC18 Slides.pdf" target="_blank">short talk</a> and <a href="assets/Lewis Mckeown Anna Jordanous ICCC18 Poster.pdf" target="_blank">poster presentation</a>.</p>
      </div>
    </CvChunk>

    <!-- 2016-2017 -->
    <CvChunk 
      yearRange="2016 - 2017" 
      jobColumnHeader="Fivium" 
      jobColumnSubHead="Placement Student"
      academiaColumnHeader="University of Kent"
      academiaColumnSubHead="Master's Degree, Computer Science with Industrial Placement"
      >
      <div slot="jobContent">
         <p>I completed a year long industrial placement at Fivium working on applications for BEIS, the Marine Management Organisation and DIT. During my placement year I was an active participant in calls and meetings with key stakeholders to undertake requirements gathering and helped deliver software which solved complex customer needs.</p>
          <p>At Fivium I got the opportunity to learn and work with tools such as FOXopen, Oracle SQL and PL/SQL (including completing the Oracle 12c SQL fundamentals certification, 1Z0-061), the Play framework, Python and many more.</p>
      </div>
      <p slot="academiaContent">I completed a year long industrial placement with Fivium as part of the University of Kent's placement programme.</p>
    </CvChunk>
    
    <!-- 2014-2016 -->
    <CvChunk 
      yearRange="2014 - 2016" 
      academiaColumnHeader="Internet Traffic Ltd" 
      academiaColumnSubHead="IT Thing Do-er"
      jobColumnHeader="University of Kent"
      jobColumnSubHead="Master's Degree, Computer Science with Industrial Placement"
      >
      <div slot="academiaContent">
         <p>During my time at ITL I was responsible for a host of technical and infrastructure related duties such as:</p>
          <ol>
            <li>Javascript that enhanced the functionality of Google Sheets used in several offices</li>
            <li>Helping set up the entire office network, from running CAT5 cable to managing openDNS</li>
            <li>Regularly using SSH, cPanel and WHM to maintain a VPS hosting multiple websites</li>
            <li>Automating server tasks with cron jobs to increase efficiency</li>
            <li>Designing and maintaining MySQL databases</li>
            <li>Fielded queries from mice not working to trouble accessing a VPS</li>
          </ol>
      </div>
      <div slot="jobContent">
         <p>I was awarded a Masters of Science with Distinction and completed modules ranging from logic and logic programming to a year long industrial placement working on government workflow applications.</p>

        <p>My <router-link to="/thesis">MSc dissertation</router-link> focused on computational creativity and narrative generation and was awarded the School of Computing Prize for Outstanding Performance for my graduating year.</p>

        <p>I also presented <a href="http://computationalcreativity.net/iccc2018/sites/default/files/iccc_proc18.pdf" target="_blank">a paper</a> based on my work at <a href="http://computationalcreativity.net/iccc2018/" target="_blank">the 9th International Conference on Computational Creativity in Salamanca, Spain in 2018</a>.</p>
      </div>
    </CvChunk>

     <!-- 2011-2014 -->
     <CvChunk 
      yearRange="2011 - 2014" 
      academiaColumnHeader="University of Sussex"
      academiaColumnSubHead="Bachelor's Degree, 2:1 Philosophy"
      >
      <div slot="academiaContent">
         <p>My studies focused on logic and language and political philosophy. They provided me with a solid, functional knowledge of predicate and propositional logic and good academic research and writing skills.</p>
      </div>
    </CvChunk>
  </div>
</template>

<script>
import CvChunk from './CvChunk.vue'

export default {
  name: 'CvChrono',
  components: {
    CvChunk
  },
}
</script>